import { UseFormReturn } from "react-hook-form";
import TextEditor from "../Global/Editors/TextEditor";
import NumberEditor from "../Global/Editors/NumberEditor";
import { DTOModule } from "../../types/building";
import { useGlobalData } from "../GlobalDataProvider";
import StaticBox from "../Global/StaticBox";
import { nameof } from "../Global/Utils";
import { IModuleVentilationFXochFConfig } from "../../types/ModuleDatas";
import SelectEditor from "../Global/Editors/SelectEditor";
import { ModuleTypeId } from "../../types/DBTables";
import ConfigVarmePrimarPump from "./ConfigVarmePrimarPump";
import { MapTooltip } from "../../types/globalData";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
}

const ConfigVentilationFXochF = ({ module, data, formHook }: IProps) => {
  const globalData = useGlobalData();

  const { watch } = formHook;

  const isFX = module.moduleTypeId === ModuleTypeId.VentilationFX;

  const variabeltFlödeList = globalData.data?.Ventilation.VariabeltFlöde.map((v) => v.VariabeltFlöde) || [];

  const motoreffektList = globalData.data?.Ventilation.Motoreffekt.map((v) => v.Motoreffekt) || [];

  const harReduceratLuftflödeFlödesreglering = watch(nameof<IModuleVentilationFXochFConfig>("harReduceradeLuftflödeFlödesreglering"));
  const harReduceradeLuftflödeTryckreglering = watch(nameof<IModuleVentilationFXochFConfig>("harReduceradeLuftflödeTryckreglering"));

  const motoreffektUppgift = watch(nameof<IModuleVentilationFXochFConfig>("motoreffektUppgift"));

  return (
    <>
      <div className="row ml-0  align-items-end">
        <div className="col-lg-6">
          <SelectEditor
            label="Ange om ventilationssystemet har flödesreglering (Ja/Nej)"
            fieldName={nameof<IModuleVentilationFXochFConfig>("harReduceradeLuftflödeFlödesreglering")}
            tooltipId={nameof<MapTooltip>("VentilationFXoF_harReduceradeLuftflödeFlödesreglering")}
            items={["", "Ja", "Nej"]}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste fyllas i" : undefined;
                },
              },
            }}
            formHook={formHook}
          />
        </div>
        <div className="col-lg-6">
          <NumberEditor
            label="Vid reducerat flöde med reglerbara rumsdon- ange normal andel av aggregatets maxflöde (%)"
            fieldName={nameof<IModuleVentilationFXochFConfig>("reduceratFlödeFlödesreglering")}
            tooltipId={nameof<MapTooltip>("VentilationFXoF_reduceratFlödeFlödesreglering")}
            isDisabled={harReduceratLuftflödeFlödesreglering === "Ja" ? false : true}
            min={0}
            max={100}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste fyllas i" : undefined;
                },
              },
            }}
          />
        </div>
      </div>
      <div className="row ml-0  align-items-end">
        <div className="col-lg-6">
          <SelectEditor
            label="Ange om ventilationssystemet har tryckreglering (Ja/Nej)"
            fieldName={nameof<IModuleVentilationFXochFConfig>("harReduceradeLuftflödeTryckreglering")}
            tooltipId={nameof<MapTooltip>("VentilationFXoF_harReduceradeLuftflödeTryckreglering")}
            items={["", "Ja", "Nej"]}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste fyllas i" : undefined;
                },
              },
            }}
          />
        </div>
        <div className="col-lg-6">
          <NumberEditor
            label="Reducerat tryck- ange andel av maxtryck (%)"
            fieldName={nameof<IModuleVentilationFXochFConfig>("reduceratFlödeTryckreglering")}
            tooltipId={nameof<MapTooltip>("VentilationFXoF_reduceratFlödeTryckreglering")}
            isDisabled={harReduceradeLuftflödeTryckreglering === "Ja" ? false : true}
            min={0}
            max={100}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste fyllas i" : undefined;
                },
              },
            }}
          />
        </div>
      </div>

      <div className="row ml-0  align-items-end">
        <div className="col-lg-6">
          <SelectEditor
            label="Ange vilken teknisk metod som används för variabelt flöde."
            fieldName={nameof<IModuleVentilationFXochFConfig>("variabeltFlödeReglermetod")}
            tooltipId={nameof<MapTooltip>("VentilationFXoF_variabeltFlödeReglermetod")}
            isDisabled={!(harReduceradeLuftflödeTryckreglering === "Ja" || harReduceratLuftflödeFlödesreglering === "Ja")}
            items={variabeltFlödeList}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste fyllas i" : undefined;
                },
              },
            }}
          />
        </div>
      </div>
      {harReduceradeLuftflödeTryckreglering === "Ja" || harReduceratLuftflödeFlödesreglering === "Ja" ? <></> : <></>}

      <div className="row ml-0 mt-4">
        <h5>Motoreffekt ventilationsaggregat </h5>
      </div>
      <div className="row ml-0  align-items-end">
        <div className="col-lg-6">
          <SelectEditor
            label="Uppgift om motoreffekt ventilationsaggregat"
            fieldName={nameof<IModuleVentilationFXochFConfig>("motoreffektUppgift")}
            tooltipId={nameof<MapTooltip>("VentilationFXoF_motoreffektUppgift")}
            items={motoreffektList}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste fyllas i" : undefined;
                },
              },
            }}
          />
        </div>
      </div>
      {motoreffektUppgift === "Uppgift saknas" ? (
        <div className="row ml-0  align-items-end">
          <div className="col-lg-12">
            <label className="form-label w-100">
              <div className="input-group">
                <input disabled={true} className="form-control" value={"Schablonvärde beräknas (Motoreffekt TF+FF KW)"} />
              </div>
            </label>
          </div>
        </div>
      ) : (
        <div className="row ml-0  align-items-end">
          <div className="col-lg-6">
            <NumberEditor
              label="Ange motoreffekt frånluft vid max kapacitet (Kilowatt KW)"
              fieldName={nameof<IModuleVentilationFXochFConfig>("motoreffektFrånluft")}
              tooltipId={nameof<MapTooltip>("VentilationFXoF_motoreffektFrånluft")}
              min={0.1}
              max={20}
              step={0.1}
              formHook={formHook}
              options={{
                validate: {
                  required: (v) => {
                    return !v ? "Måste fyllas i" : undefined;
                  },
                },
              }}
            />
          </div>
        </div>
      )}
      {/********************  Värmepump  */}
      {isFX ? (
        <>
          <div className="row ml-0 mt-4">
            <h5>Värmepump </h5>
          </div>
          <ConfigVarmePrimarPump module={module} formHook={formHook} data={data} usedAsFXSubsystem={true} />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ConfigVentilationFXochF;
